export default "/assets/font_family_tisa-b5aa4ec77349fca97dd3b8c1371a994cf1865cec42478d4449b2a92f63b5ef01.svg";